<div class="graph-stats-container">
  <div class="stats">
    @for (stat of cashflowStats(); track $index) {
      <div [class]="'wealth-info ' + stat.classes">
        <div tooltipPosition="bottom" [appTooltip]="stat.tooltip" class="default-cursor title">{{ stat.label }}</div>
        <div
          [ngClass]="{ negative: stat.value < 0 }"
          [tooltipStyleClass]="stat.value < 0 ? 'negative' : ''"
          [appTooltip]="stat.value | money: 'positiveComa'"
        >
          {{ stat.value | money: 'shortSimpleSpace' }}
        </div>
      </div>
    }
  </div>
</div>
